var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {
      staticClass: "full-width bg-grey-10",
      staticStyle: { height: "1px" }
    }),
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "flex-start",
          "flex-flow": "row wrap",
          "align-items": "center",
          padding: "1rem",
          "font-weight": "bold"
        }
      },
      [
        _c("div", { staticStyle: { width: "25%" } }, [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("finances_revenues")) + " " + _vm._s(_vm.time))
          ]),
          _c("span", { staticStyle: { color: "green" } }, [
            _vm._v(_vm._s(_vm.revenue))
          ])
        ]),
        _c("div", { staticStyle: { width: "25%", "margin-left": "2rem" } }, [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("finances_expenses")) + " " + _vm._s(_vm.time))
          ]),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(_vm._s(_vm.expense))
          ])
        ])
      ]
    ),
    _c("div", {
      staticClass: "full-width bg-grey-10",
      staticStyle: { height: "1px" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }